export default __webpack_public_path__ + "static/media/astro_girl.9424ff42.webp";